module.exports = __webpack_public_path__ + "img/small-clouds.5841bb03.png";